import { render, staticRenderFns } from "./BackGlyph.vue?vue&type=template&id=44b01bc2&"
import script from "./BackGlyph.vue?vue&type=script&lang=js&"
export * from "./BackGlyph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports